import { useBreadcrumb } from "@/ui-components/ui/breadcrumb/breadcrumb-context";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/ui-components/ui/card";
import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import LoomPlayer from "@/ui-components/ui/loom-player";
import { Play } from "lucide-react";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { HelpVideo, mockedHelpArticles } from "./root-component";

const Help = () => {
  const { setTitle } = useBreadcrumb();
  const [searchParams, setSearchParams] = useSearchParams();
  const [contentId, setContentId] = useState<number>(Number(searchParams.get("id") ?? 1));
  const [content, setContent] = useState<HelpVideo | null>(null);

  useEffect(() => {
    if (setTitle) {
      setTitle("Hilfe");
    }
  }, [setTitle]);

  useEffect(() => {
    const contentId = searchParams.get("id");
    if (contentId) {
      setContentId(Number(contentId));
    } else {
      setContentId(1);
      setSearchParams({ id: "1" });
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    const article = mockedHelpArticles.find((article) => article.id === Number(contentId));
    if (article) {
      setContent(article);
    }
  }, [contentId]);

  const renderContent = () => {
    if (!content) return null;

    return (
      <Card className="overflow-hidden shadow-lg max-w-4xl mx-auto">
        <CardHeader
          className="bg-gradient-to-r from-[#0f2a2c] to-[#12282A] text-white"
        >
          <div className="flex items-center">
            <Play className="mr-2" size={20} />
            <CardTitle className="text-2xl">{content.title}</CardTitle>
          </div>
        </CardHeader>

        {content.loomId ? (
          <LoomPlayer videoId={content.loomId} />
        ) : (
          <div className="p-6 bg-gray-100">
            <div className="flex items-center justify-center">
              <Play size={64} className="text-[#1059E6]" />
            </div>
          </div>
        )}

        <CardContent className="pt-6">
          <div className="space-y-4">
            <div className="flex items-center">
              <h3 className="text-lg font-semibold">Beschreibung</h3>
              <div
                className="ml-2 px-2 py-1 bg-[#e6f0ff] text-[#1059E6] text-xs rounded-full"
              >
                Video {content.id} von {mockedHelpArticles.length}
              </div>
            </div>
            <CardDescription className="text-base leading-relaxed">{content.description}</CardDescription>

            <div className="pt-4 border-t border-gray-100 mt-6">
              <div className="flex justify-between">
                {content.id !== 1 ? (
                  <button
                    className="px-4 py-2 bg-[#0f2a2c] hover:bg-[#12282A] text-white rounded-md transition-colors"
                    onClick={() => {
                      const prevId = content.id > 1 ? content.id - 1 : mockedHelpArticles.length;
                      setSearchParams({ id: prevId.toString() });
                    }}
                  >
                    Vorheriges Video
                  </button>
                ) : (
                  <div className="w-10"></div>
                )}
                {content.id !== mockedHelpArticles.length ? (
                  <button
                    className="px-4 py-2 bg-[#1059E6] hover:bg-[#0d47b8] text-white rounded-md transition-colors"
                    onClick={() => {
                      const nextId = content.id < mockedHelpArticles.length ? content.id + 1 : 1;
                      setSearchParams({ id: nextId.toString() });
                    }}
                  >
                    Nächstes Video
                  </button>
                ) : (
                  <div className="w-10"></div>
                )}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  };

  return (
    <div className="p-6">
      <PageTitleContainer>
        <PageTitle>Hilfe</PageTitle>
      </PageTitleContainer>
      {renderContent()}
    </div>
  );
};

export default Help;
